import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=767acd30"
import script from "./SignUpForm.vue?vue&type=script&lang=js"
export * from "./SignUpForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports